import { Link , NavLink} from 'react-router-dom'
import './index.scss'
import LogoS from '../../assets/images/logo-s.png'
import LogoSubtitle from '../../assets/images/logo_sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
import { faHome, faUser,faEnvelope, faBoxArchive } from '@fortawesome/free-solid-svg-icons'


const Sidebar = () => (
    <div className="nav-bar">
        {/* <Link className='logo' to="/">
        </Link> */}


            <nav>
                <NavLink exact="true" activeclassname="active" to="/portfolio">
                    <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="about-link" to="/about">
                    <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="portfolio-link" to="/work">
                    <FontAwesomeIcon icon={faBoxArchive} color="#4d4d4e" />
                </NavLink>
                <a href = "mailto:adithyapalle12@gmail.com?subject = Feedback&body = Message" exact="true" activeclassname="active" className="contact-link" >
                    <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
                </a>
        
                
            </nav>

            <ul>
                <li>
                    <a
                    target =  "_blank"
                    rel = "noreferrer"
                    href= "https://www.linkedin.com/in/adithya-palle-400954217/"
                    >
                        <FontAwesomeIcon icon = {faLinkedin} color = '#4d4d43'/>
                    </a>
                </li>
                <li>
                    <a
                        href="https://github.com/4di03"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
                    </a>
                </li>

            </ul>
    </div>
)


export default Sidebar